module.exports = __webpack_public_path__ + "img/aha-slides-gpt-1.9b65dbe9.webp";